
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';

const SelectUserType = forwardRef((props, ref) => {
    return (
        <React.Fragment>
            <div className="card mt-3">
                <div className="card-body">  
                    <div className="row text-center">
                        <div className="col-md-12">
                            <h4>Si ya eres usuario registrado, haz clic en el botón "Usuario Registrado"; de lo contrario, selecciona el botón "Registrarse" para crear tu cuenta.</h4>
                        </div>

                        <div className="col-md-6 text-right mt-4">
                            <button className='btn btn-primary' onClick={() => props.toogleTab("user_login")}>Usuario registrado</button>
                        </div>

                        <div className="col-md-6 text-left mt-4">
                            <button className='btn btn-primary' onClick={() => props.toogleTab("user_form")}>Registrarse</button>
                        </div>
                    </div>
                </div>
            </div>     
        </React.Fragment>
    );
});


export default SelectUserType;
